import tw, { styled } from 'twin.macro';

export const LegalTextWrap = styled.div`
  ${tw`text-[14px] text-neutrals-n7 text-left`}
  ${tw`font-inter font-regular`}
  ${tw`leading-[21px]`}
  a {
    ${tw`underline`}
  }
  > p {
    ${tw`inline`}
  }
`;
